import type { ExplicitAddress } from '@cronos-app/sdk';
import { useH2ReceiveAmount } from '@ui/hooks/h2/useH2ReceiveAmount';
import { Fraction } from 'bi-fraction';

import {
  useH2SwapFromTokenInfo,
  useH2SwapToTokenInfo,
} from '../../useH2SwapDialog';
import { useH2SwapSlippageDialog } from '../H2SwapSlippageDialog/useH2SwapSlippageDialog';
import { useH2SwapForm } from './useH2SwapForm';

export const useToTokenAmount = (
  amount?: Fraction,
  considerSlippage = false,
) => {
  const formEnteredAmount = useH2SwapForm((s) => s.enteredAmount);
  const enteredAmount = amount ?? formEnteredAmount;

  const slippage = useH2SwapSlippageDialog((s) => s.entered);
  const fromTokenConfig = useH2SwapFromTokenInfo();
  const toTokenConfig = useH2SwapToTokenInfo();
  const mode = useH2SwapForm((s) => s.mode);

  const expectedReceive = useH2ReceiveAmount(
    {
      amountIn: enteredAmount,
      inputTokenAddress: fromTokenConfig?.address ?? '',
      inputTokenDecimals: fromTokenConfig?.decimals ?? 18,
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      outputTokenAddress: (toTokenConfig?.address ?? '') as ExplicitAddress,
      outputTokenDecimals: toTokenConfig?.decimals ?? 18,
      slippage,
      mode,
    },
    !!fromTokenConfig && !!toTokenConfig,
  ).data;

  if (enteredAmount.lte(Fraction.ZERO)) return Fraction.ZERO;

  return considerSlippage
    ? expectedReceive?.withSlippage
    : expectedReceive?.withoutSlippage;
};
